import React, { useEffect, useState } from "react";
import * as API from "../../utils/api.service";
import { TOAST_ERROR } from "../../utils/common.service";
import { useParams } from "react-router-dom";

const TermsCondition = () => {
  const [termsCondition, setTermsCondition] = useState("");
  const { lang } = useParams();

  useEffect(() => {
    const fetchTermsConditionContent = async () => {
      try {
        const response = await API.getAppContentApi();
        if (lang == "ar") {
          setTermsCondition(response?.data?.ar_terms_condition_content || "");
        } else {
          setTermsCondition(response?.data?.terms_condition_content || "");
        }
      } catch (error) {
        TOAST_ERROR("Failed to load content");
      }
    };

    fetchTermsConditionContent();
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="content" dir={lang === "ar" ? "rtl" : "ltr"}>
            <h1 className="d-flex justify-content-center mt-3 mb-3">
              {lang == "ar" ? "الشروط والأحكام" : "Terms And Condition"}
            </h1>
            <div dangerouslySetInnerHTML={{ __html: termsCondition }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsCondition;
